<h3 class="text-center width-100">
  Image Block
  <i
    class="fa fa-times pull-right close-sidenav"
    aria-hidden="true"
    title="Close Text Block"
    (click)="closeNav()"
  ></i>
</h3>
<!-- 3 STEP PROCESS FORM: SETTINGS, SEARCH LISTING, AND LISTING RESULTS -->
<div class="container-fluid">
  <div class="edit row width-100 padding-0-25">
    <!-- Title and Title color -->
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="name">Title</label>
        <input
          type="text"
          class="form-control"
          id="name"
          aria-describedby="title"
          placeholder="Title"
          [(ngModel)]="title"
        />
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="color">Title Color</label>
        <br />
        <input
          type="text"
          class="form-control color"
          id="color"
          aria-describedby="Title Color"
          placeholder="Font Color"
          [(ngModel)]="color"
        />
        <button
          role="button"
          type="button"
          aria-label="Choose Color"
          class="btn btn-circle"
          [style.background]="color"
          [(colorPicker)]="color"
        ></button>
      </div>
    </div>

    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="photo">Image Upload</label>
        <input
          type="file"
          class="form-control"
          name="photo"
          id="photo"
          (change)="onFileSelected($event)"
          accept="image/*"
        />
        @if (selectedFile) {
          <button
            role="button"
            aria-label="Upload Image"
            type="button"
            class="btn btn-outline-primary margin-10-0"
            (click)="uploadImage()"
            [disabled]="isUploading"
          >
            @if (isUploading) {
              Uploading...
            } @else {
              Upload Image
            }
          </button>
        }
      </div>
      <!-- PREVIEWING THE IMAGE -->
      @if (fileUploadCheck === false) {
        <div class="text-center width-320 height-150 back-shade-two color-offset-four">
          <!-- <span class="inline-block padding-40">For Best Results use an 1200px width image to cover large monitors.</span> -->
          <span class="inline-block padding-40"
            >For Best Results use an image that is less than 1200px width to cover large
            monitors.</span
          >
        </div>
      }
      @if (fileUploadCheck === true) {
        <div class="text-center">
          <img [src]="imgUrl" alt="Uploaded Photo" style="max-width: 300px; max-height: 200px" />
        </div>
      }
    </div>
  </div>

  <!-- MORE OPTIONS -->
  <div class="edit row width-100 padding-0-25">
    <div class="col-12 margin-5-0">
      <div class="form-group margin-10-0">
        <label for="image-alt-text">Image Alternate Text</label>
        <input
          type="text"
          class="form-control"
          id="image-alt-text"
          aria-describedby="image alternate text"
          placeholder="Image Alternate Text"
          [(ngModel)]="imgTitle"
        />
      </div>
    </div>

    <div class="col-12 margin-5-0">
      <div class="form-group margin-10-0">
        <label for="targetUrl">Target URL</label>
        <input
          type="text"
          class="form-control"
          id="targetUrl"
          aria-describedby="Target URL"
          placeholder="Enter URL"
          [(ngModel)]="targetUrl"
        />
      </div>
    </div>

    <div class="col-12">
      <button
        role="button"
        type="button"
        aria-label="More options"
        class="btn btn-link"
        (click)="isCollapsed = !isCollapsed"
      >
        More Options
        @if (isCollapsed) {
          <i class="fa fa-caret-right" aria-hidden="true"></i>
        }
        @if (!isCollapsed) {
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        }
      </button>
    </div>
  </div>
  <div class="width-100 padding-0-25" [ngbCollapse]="isCollapsed">
    <!-- IMAGE PROPERTIES -->
    <div class="block row text-center margin-15-0">
      <h3>
        Image Block Properties
        <i
          class="fa fa-question-circle-o"
          aria-hidden="true"
          style="margin-left: 5px"
          matTooltip="Change the Appearance of the uploaded image. See links underneath the input values to get more in detailed explanations on that property."
          [matTooltipPosition]="'right'"
        >
        </i>
      </h3>
    </div>
    <div class="edit row">
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="width">Width</label>
          <input
            type="text"
            class="form-control"
            id="width"
            aria-describedby="width"
            placeholder="ex. 100% or 250px"
            [(ngModel)]="width"
          />
          <small id="widthHelp" class="form-text text-muted"
            >Specify image to constant width. Numbers followed by "px", "%", "vw".
            <a href="https://www.w3schools.com/cssref/pr_dim_width.asp" target="_blank"
              >for width values</a
            >
          </small>
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="height">Height</label>
          <input
            type="text"
            class="form-control"
            id="height"
            aria-describedby="height"
            placeholder="ex. 100% or 250px"
            [(ngModel)]="height"
          />
          <small id="heightHelp" class="form-text text-muted"
            >Specify image to constant height. Numbers followed by "px", "%", "vh".
            <a href="https://www.w3schools.com/cssref/pr_dim_height.asp" target="_blank"
              >for height values</a
            >
          </small>
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <!-- <label for="align">Alignment</label> -->
          <label for="align">Image Postion</label>
          <i
            class="fa fa-info"
            aria-hidden="true"
            style="margin-left: 5px"
            matTooltip="Image position property sets the starting position of a background images"
            [matTooltipPosition]="'right'"
          >
          </i>
          <input
            type="text"
            class="form-control"
            id="align"
            aria-describedby="align"
            placeholder="alignment values"
            [(ngModel)]="align"
          />
          <small id="alignHelp" class="form-text text-muted"
            >Represents horizontal alignment of the image. <br />
            Enter "left","center", or "right".</small
          >
        </div>
      </div>
      <!-- <div class="col-12 margin-5-0">
                              <div class="form-group">
                                <label for="maxWidth">Max Width</label>
                                <input type="text" class="form-control" id="maxWidth" aria-describedby="maxWidth" placeholder="ex. 100% or 250px" [(ngModel)]="maxWidth">
                                <small id="maxWidthHelp" class="form-text text-muted">Aid landscape/portait images. Numbers followed by "px", "%", "vw".
                                  <a href="https://www.w3schools.com/cssref/pr_dim_max-width.asp" target="_blank">for max-width values</a>
                                </small>
                              </div>
                            </div> -->
      <!-- <div class="col-12 margin-5-0">
                            <div class="form-group">
                              <label for="maxHeight">Max Height</label>
                              <input type="text" class="form-control" id="maxHeight" aria-describedby="maxHeight" placeholder="ex. 150px or 50vh" [(ngModel)]="maxHeight">
                              <small id="maxHeightHelp" class="form-text text-muted">Aid landscape/portait images. Numbers followed by "px", "%", "vw".
                                <a href="https://www.w3schools.com/cssref/pr_dim_max-height.asp" target="_blank">for max-height values</a>
                              </small>
                            </div>
                          </div> -->
      <!-- <div class="col-12 margin-5-0">
                          <div class="form-group">
                            <label for="marginLeft">Left Spacing</label>
                            <input type="text" class="form-control" id="marginLeft" aria-describedby="marginLeft" placeholder="ex. 10% or 25px" [(ngModel)]="marginLeft">
                            <small id="marginLeftHelp" class="form-text text-muted">Additional Left Spacing. Numbers followed by "px", "%", "vw".
                              <br />
                              <a href="https://www.w3schools.com/cssref/css_units.asp" target="_blank">for more unit values</a>
                            </small>
                          </div>
                        </div> -->
      <!-- <div class="col-12 margin-5-0">
                        <div class="form-group">
                          <label for="paddingTop">Top Spacing</label>
                          <input type="text" class="form-control" id="paddingTop" aria-describedby="paddingTop" placeholder="ex. 10% or 25px" [(ngModel)]="paddingTop">
                          <small id="paddingTopHelp" class="form-text text-muted">Additional Top Spacing . Numbers followed by "px", "%", "vw".
                            <br />
                            <a href="https://www.w3schools.com/cssref/css_units.asp" target="_blank">for more unit values</a>
                          </small>
                        </div>
                      </div> -->
      <!-- <div class="col-12 margin-5-0">
                      <div class="form-group">
                        <label for="marginRight">Right Spacing</label>
                        <input type="text" class="form-control" id="marginRight" aria-describedby="marginRight" placeholder="ex. 10% or 25px" [(ngModel)]="marginRight">
                        <small id="marginRightHelp" class="form-text text-muted">Additional Right Spacing . Numbers followed by "px", "%", "vw".
                          <br />
                          <a href="https://www.w3schools.com/cssref/css_units.asp" target="_blank">for more unit values</a>
                        </small>
                      </div>
                    </div> -->
      <!-- <div class="col-12 margin-5-0">
                    <div class="form-group">
                      <label for="paddingBottom">Bottom Spacing</label>
                      <input type="text" class="form-control" id="paddingBottom" aria-describedby="paddingBottom" placeholder="ex. 10% or 25px"
                        [(ngModel)]="paddingBottom">
                        <small id="paddingBottomHelp" class="form-text text-muted">Additional Bottom Spacing . Numbers followed by "px", "%", "vw".
                          <br />
                          <a href="https://www.w3schools.com/cssref/css_units.asp" target="_blank">for more unit values</a>
                        </small>
                      </div>
                    </div> -->

      <!-- <div class="col-12 margin-5-0">
                    <div class="form-group">
                      <label for="display">Display Property</label>
                      <input type="text" class="form-control" id="display" aria-describedby="display" placeholder="ex. inline-block" [(ngModel)]="display">
                      <small id="displayHelp" class="form-text text-muted">Optional Layout Display.
                        <a href="https://www.w3schools.com/cssref/pr_class_display.asp" target="_blank">for more display values</a>
                      </small>
                    </div>
                  </div> -->
      <!-- <div class="col-12 margin-5-0">
                  <div class="form-group">
                    <label for="border">Border Radius</label>
                    <input type="text" class="form-control" id="border" aria-describedby="border" placeholder="ex. 50% or 25px" [(ngModel)]="border">
                    <small id="borderHelp" class="form-text text-muted">Optional Border Radius.
                      <a href="https://www.w3schools.com/css/css3_images.asp" target="_blank">for more border-radius values</a>
                    </small>
                  </div>
                </div> -->
      <!-- <div class="col-12 margin-5-0">
                <div class="form-group">
                  <label for="opacity">Image Opacity</label>
                  <input type="text" class="form-control" id="opacity" aria-describedby="opacity" placeholder="0.0 through 1.0" [(ngModel)]="opacity">
                  <small id="opacityHelp" class="form-text text-muted">Optional Image Opacity.</small>
                </div>
              </div> -->
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="opacity">Opacity</label>
          <i
            class="fa fa-info"
            aria-hidden="true"
            style="margin-left: 5px"
            matTooltip="The opacity-level describes the transparency-level, where 1 is not transparent at all, 0.5 is 50%
                                        see-through, and 0 is completely transparent."
            [matTooltipPosition]="'right'"
          >
          </i>
          <input
            type="text"
            class="form-control"
            id="opacity"
            aria-describedby="opacity"
            placeholder="0.0 through 1.0"
            [(ngModel)]="opacity"
          />
          <!-- <small id="opacityHelp" class="form-text text-muted">Optional Image Opacity.</small> -->
          <small id="backOpacityHelp" class="form-text text-muted"
            >Set the Transparency Level of the Backgound and/or Image</small
          >
        </div>
      </div>
      <!-- <div class="col-12 margin-5-0">
                  <div class="form-group">
                    <label for="transform">Transform</label>
                    <input type="text" class="form-control" id="transform" aria-describedby="transform" placeholder="ex. scaleY(1.5) or rotate(20deg)"
                      [(ngModel)]="transform">
                      <small id="transformHelp" class="form-text text-muted">Add Image Transformation.
                        <a href="https://www.w3schools.com/cssref/css3_pr_transform.asp" target="_blank">for more transform values</a>
                      </small>
                    </div>
                  </div> -->
    </div>
    <!-- DESIGN STYLES -->
    <div class="block row text-center margin-15-0">
      <h3>
        Design Elements
        <i
          class="fa fa-question-circle-o"
          aria-hidden="true"
          style="margin-left: 5px"
          matTooltip="Change the background color, flush in template with no outer margins, and add additional classes for this component."
          [matTooltipPosition]="'right'"
        >
        </i>
      </h3>
    </div>
    <div class="edit row">
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="background">Image Background Color</label>
          <br />
          <input
            type="text"
            class="form-control color"
            id="background"
            aria-describedby="Background"
            placeholder="Enter Background Color"
            [(ngModel)]="background"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Color"
            class="btn btn-circle"
            [style.background]="background"
            [(colorPicker)]="background"
          ></button>
        </div>
      </div>
      <div class="col-12 margin-5-0 padding-10-0">
        <div class="form-check">
          <label for="flush" class="form-check-label">
            <input
              style="
                width: 20px;
                height: 20px;
                margin-right: 5px;
                position: relative;
                vertical-align: bottom;
              "
              type="checkbox"
              class="form-check-input"
              id="flush"
              [(ngModel)]="flushed"
            />Flush in template.
          </label>
        </div>
      </div>
      <!-- <div class="col-12 margin-5-0">
                      <div class="form-group">
                        <label for="className">Additional Classes
                          <i class="fa question-help fa-question-circle-o" aria-hidden="true" matTooltip="Add additional classes through the CSS Editor"
                          [matTooltipPosition]="'after'"></i>
                        </label>
                        <input type="text" class="form-control" id="className" aria-describedby="Additional Class Names defined through the CSS Editor"
                          placeholder="class names defined from CSS editor" [(ngModel)]="className">
                        </div>
                      </div> -->
    </div>
  </div>

  <div class="edit row">
    <div class="col-12 margin-25-0 text-end">
      <button
        role="button"
        type="button"
        aria-label="Preview"
        class="btn btn-link"
        style="left: initial"
        (click)="updateIMAGE()"
      >
        Preview
      </button>
      <button
        role="button"
        type="button"
        aria-label="Save and Close"
        class="btn btn-primary"
        style="left: initial"
        (click)="submitIMAGE()"
      >
        Save and Close
      </button>
    </div>
  </div>
</div>
